import * as React from 'react';
import * as styles from './styles.css';
import { CheckboxButton } from '@cian/ui-kit';

import { IOptionsRendererProps } from '../../types';
import { EPreciseFilterValues } from '../../../../types/redux/preciseFilters';

export const CheckboxGroupRenderer: React.FC<IOptionsRendererProps> = props => {
  const { options, onChange, filterState, disabled } = props;

  const handleValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value as EPreciseFilterValues;

    onChange(value);
  };

  return (
    <ul className={styles['container']}>
      {options.map(option => {
        const isChecked = filterState.includes(option.name);
        const isDisabled = !isChecked && disabled;

        return (
          <li key={option.name} className={styles['option']}>
            <CheckboxButton
              disabled={isDisabled}
              label={option.displayName}
              onChange={handleValueChange}
              value={option.name}
              checked={isChecked}
            />
          </li>
        );
      })}
    </ul>
  );
};

CheckboxGroupRenderer.displayName = 'CheckboxGroupRenderer';
